module.exports = function() {
  return new Worker(__webpack_public_path__ + "7d80f8b501d676d72b2b.worker.js");
};